import { createSlice } from "@reduxjs/toolkit";
import { reset } from "../resetParameters";

const initialState = {
  title: "TITAN 30/11",
};

// TODO: remove and merge with innere
const selectedTraggliedSlice = createSlice({
  name: "tragglied",
  initialState,
  reducers: {
    setTraggliedState(state, action) {
      state.title = action.payload.title;
    },
    setSelectedTragglied(state, action) {
      state.title = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(reset, (state, action) => {
      return initialState;
    });
  },
});

export const { setTraggliedState, setSelectedTragglied } = selectedTraggliedSlice.actions;

export default selectedTraggliedSlice.reducer;

export const selectTragglied = (state) => state.selectedTragglied;
export const selectTraggliedTitle = (state) => state.selectedTragglied.title;
